// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import { canonicalUrl } from "../utils/seo.js";
import { hasUnknownQueryParams } from "../utils/seo.js";
import * as jsxRuntime from "react/jsx-runtime";
import { siteOrigin } from "../utils/seo.js";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function PartnersPage() {
  const l = useLocation(),
    { theme: theme } = useTheme(),
    { language: language, t: t, tText } = useLanguage(),
    [d, f] = React.useState([]),
    [m, y] = React.useState(true);
  React.useEffect(() => {
    async function N() {
      try {
        const T = await api.get("/partners");
        f(T.data || []);
      } catch (T) {
        console.error("Error loading partners", T);
      } finally {
        y(false);
      }
    }
    N();
  }, []);
  const g = theme?.site_name || "MyShop",
    p = siteOrigin(),
    b = canonicalUrl(p, "/partners"),
    x = hasUnknownQueryParams(l.search),
    O = language === "ar" ? "شركاؤنا" : "Our partners",
    H =
      language === "ar"
        ? `تعرّف على الشركاء والعلامات التجارية التي نعمل معها في ${g}.`
        : `Meet the partners and brands that collaborate with ${g}.`,
    E = theme?.logo || null,
    M = b
      ? [
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": `${b}#collection`,
            name: O,
            description: H,
            url: b,
            image: E || void 0,
            isPartOf: {
              "@id": `${canonicalUrl(p, "/")}#website`,
            },
            mainEntity:
              d.length > 0
                ? {
                    "@id": `${b}#partner-list`,
                  }
                : void 0,
          },
          ...(d.length
            ? [
                {
                  "@context": "https://schema.org",
                  "@type": "ItemList",
                  "@id": `${b}#partner-list`,
                  name: O,
                  numberOfItems: d.length,
                  itemListElement: d.map((N, T) => ({
                    "@type": "ListItem",
                    position: T + 1,
                    item: {
                      "@type": "Organization",
                      name: N.name || (language === "ar" ? "شريك" : "Partner"),
                      logo: N.photo_url
                        ? N.photo_url.startsWith("http")
                          ? N.photo_url
                          : `${MEDIA_BASE_URL}${N.photo_url}`
                        : void 0,
                    },
                  })),
                },
              ]
            : []),
        ]
      : [];
  return m ? (
    <jsxRuntime.Fragment>
      <Seo
        title={O}
        description={H}
        image={E}
        imageAlt={g}
        canonicalUrl={b || void 0}
        type={"website"}
        siteName={g}
        language={language}
        noindex={x}
        schema={M}
      />
      <AppLoading
        variant={"page"}
        layout={"partners"}
        brand={g}
        label={t("loadingPartners")}
        detail={
          language === "ar"
            ? "نجهّز العلامات والشركاء الذين تثق بهم."
            : "Preparing the brands and partners you can trust."
        }
      />
    </jsxRuntime.Fragment>
  ) : (
    <div className={"page partners-page storefront-page"}>
      <Seo
        title={O}
        description={H}
        image={E}
        imageAlt={g}
        canonicalUrl={b || void 0}
        type={"website"}
        siteName={g}
        language={language}
        noindex={x}
        schema={M}
      />
      <div className={"partners-hero"}>
        <p className={"partners-kicker"}>{t("trustedNetwork")}</p>
        <h1 className={"partners-title"}>{t("partnersMainTitle")}</h1>
        <p className={"partners-subtitle"}>{t("partnersSubtitle")}</p>
        <div className={"partners-hero-stats"}>
          <span>
            <b>{d.length}</b>
            {t("partnersCount")}
          </span>
          <span>
            <b>{t("qualityTitle")}</b>
            {t("selectedBrands")}
          </span>
        </div>
      </div>
      <div className={"partners-trust-strip"} aria-label={tText("Partner values")}>
        <span>{t("marquesSelectionnees")}</span>
        <span>{t("collaborationDurable")}</span>
        <span>{t("qualiteProduit")}</span>
      </div>
      {!d.length && <p className={"hint"}>{t("noPartners")}</p>}
      <div className={"partners-grid"}>
        {d.map((N, T) => {
          const Y = N.photo_url?.startsWith("http")
            ? N.photo_url
            : `${MEDIA_BASE_URL}${N.photo_url}`;
          return (
            <div
              className={"partner-card animated-card"}
              style={{
                animationDelay: `${T * 0.08}s`,
              }}
              key={N.id}
            >
              <div className={"partner-card-inner"}>
                <span className={"partner-index"}>
                  {String(T + 1).padStart(2, "0")}
                </span>
                <div className={"partner-logo-wrap"}>
                  <img
                    src={Y}
                    alt={""}
                    aria-hidden={"true"}
                    loading={"lazy"}
                    decoding={"async"}
                  />
                </div>
                <div className={"partner-card-footer"}>
                  <span className={"partner-card-name"}>
                    {N.name || "Partner"}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
export { PartnersPage };
